import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

export type UserAutoCompleteQueryParams = {
    pageNumber: number;
    pageSize: number;
    searchText?: string | null;
};

type Props = Omit<IAutoCompleteProps, 'onGetSuggestions' | 'emptyThumbnail'>;

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de idiomas de proficiência
 * @param props
 */
export const UserIdiomsAutoComplete: React.FC<Props> = (props) => {

    const api = useCoreApi();

    const { onError } = props;

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.suggestions.idioms({
                SearchText: searchText
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items,
                        totalRows: result.data.totalRows
                    });
                })
                .catch(error => {
                    if (!isCanceledError(error)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(error);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onGetSuggestions={getSuggestions}
        />
    );
};
